import { render, staticRenderFns } from "./Dimensions.vue?vue&type=template&id=006ab225&scoped=true&"
import script from "./Dimensions.vue?vue&type=script&lang=js&"
export * from "./Dimensions.vue?vue&type=script&lang=js&"
import style0 from "./Dimensions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Dimensions.vue?vue&type=style&index=1&id=006ab225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ab225",
  null
  
)

export default component.exports